import WriteTitle from '../../../src/components/content-ai-tools/WriteTitleTag';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={WriteTitle} />;
};

export default PublicDiscoveryKeywordsWrapped;
